module.exports = __webpack_public_path__ + "img/traffic-details.0c95fcee.png";